module.exports = __webpack_public_path__ + "media/images/front/top/minna_premium_plus-7afa07403c4da8c634f682d3d1548699.jpeg";